import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const ChapterHeading = ({ chapter, eyebrow, title, description, testId }) => (
    <div className="max-w-2xl" data-testid={testId}>
        <Reveal>
            <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.2em] text-brand-dark">
                <span className="font-mono text-[11px] tracking-normal text-slate-400">
                    {chapter}
                </span>
                <span className="h-px w-8 bg-brand/40" aria-hidden="true" />
                {eyebrow}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="mt-5 text-2xl font-bold tracking-tight text-ink sm:text-3xl lg:text-4xl">
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.16}>
                <p className="mt-5 text-base leading-relaxed text-slate-600 sm:text-lg">
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);
